var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tabs"},[_c('ul',_vm._l((_vm.menu),function(menuItem,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":menuItem.link}},[_vm._v(_vm._s(menuItem.name))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }